export class IngestionPipelineObservation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "observedAt",
            "baseName": "observedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "observedStatus",
            "baseName": "observedStatus",
            "type": "string",
            "format": ""
        },
        {
            "name": "health",
            "baseName": "health",
            "type": "IngestionPipelineObservationHealthEnum",
            "format": ""
        },
        {
            "name": "flinkDeployment",
            "baseName": "flinkDeployment",
            "type": "IngestionPipelineObservationFlinkDeployment",
            "format": ""
        },
        {
            "name": "pods",
            "baseName": "pods",
            "type": "Array<PodObservation>",
            "format": ""
        },
        {
            "name": "recentWarningEvents",
            "baseName": "recentWarningEvents",
            "type": "Array<K8sEventObservation>",
            "format": ""
        },
        {
            "name": "issues",
            "baseName": "issues",
            "type": "Array<IngestionPipelineIssue>",
            "format": ""
        },
        {
            "name": "issuesStale",
            "baseName": "issuesStale",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "observeError",
            "baseName": "observeError",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableFormatVersion",
            "baseName": "tableFormatVersion",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineObservation.attributeTypeMap;
    }
    constructor() {
    }
}
export var IngestionPipelineObservationHealthEnum;
(function (IngestionPipelineObservationHealthEnum) {
    IngestionPipelineObservationHealthEnum["Healthy"] = "HEALTHY";
    IngestionPipelineObservationHealthEnum["Starting"] = "STARTING";
    IngestionPipelineObservationHealthEnum["Suspended"] = "SUSPENDED";
    IngestionPipelineObservationHealthEnum["Degraded"] = "DEGRADED";
    IngestionPipelineObservationHealthEnum["Unhealthy"] = "UNHEALTHY";
    IngestionPipelineObservationHealthEnum["Missing"] = "MISSING";
    IngestionPipelineObservationHealthEnum["Unknown"] = "UNKNOWN";
})(IngestionPipelineObservationHealthEnum || (IngestionPipelineObservationHealthEnum = {}));
